module.exports = __webpack_public_path__ + "static/media/SL 22.8b056368.mp3";